import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {NumberNode} from "#template/nodes/number/number-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {ValueLikeNode} from "#template/role-markers"
import {valueMarker} from "#template/role-markers"

export type NumberValueParameters = {value: number}

const numberValueDefinition: TemplateNodeDefinition<NumberValueParameters> = {
    nodeClass: "NumberValue",
    validation: {
        parameters: z.object({value: z.number()}),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class NumberValue extends NumberNode<NumberValueParameters> implements ValueLikeNode<number> {
    get [valueMarker]() {
        return true as const
    }

    public override get definition() {
        return numberValueDefinition
    }

    public override evaluate(_scope: GraphBuilderScope, _evaluator: NodeEvaluator): BuilderInlet<number | null> {
        return this.parameters.value
    }
}
